export default __webpack_public_path__ + "static/media/premium-laundry-round.8b511fe9.png";